export default __webpack_public_path__ + "static/media/cherry.df4ce157.jpg";